import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { hero_bg } from "../../data";
import RotatingWord from "./RotatingWord";

export default function Hero() {
  return (
    <section className="relative min-h-[92vh] border-b border-ink-700 overflow-hidden" data-testid="hero">
      <div
        className="absolute inset-0 opacity-50"
        style={{
          backgroundImage: `url(${hero_bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950/40 via-ink-950/70 to-ink-950" />
      <div className="scanline-overlay" />

      <div className="absolute top-6 left-6 font-mono text-[10px] tracking-[0.2em] uppercase text-signal-phosphor flex items-center gap-2">
        <span className="dot-phosphor animate-blink" /> SYS.ONLINE
      </div>

      <div className="absolute bottom-6 right-6 font-mono text-[10px] tracking-[0.2em] uppercase text-textmuted">
        CEA / EST 2013 / V.2026
      </div>

   <div className="relative section-padding pt-16 lg:pt-20 pb-24 max-w-[1600px] mx-auto">
  <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-start">

          <div>
            <p className="overline mb-6 animate-fade-up flex items-center gap-3">
              <span className="dot-phosphor" /> Technical solutions for
            </p>

            <div
              className="font-display font-black tracking-tight text-4xl sm:text-6xl md:text-7xl lg:text-7xl leading-none mb-6 animate-fade-up h-[1.1em] max-w-[700px]"
              style={{ color: "var(--signal-amber)" }}
            >
              <RotatingWord
                words={["Education.", "Industrial.", "Automation."]}
                intervalMs={2200}
              />
            </div>

            <h1 className="h-display text-[12vw] sm:text-[10vw] md:text-[7vw] lg:text-[6rem] leading-none">
              Test, Measure,<br />
              Teach and Automate.
            </h1>

            <p className="mt-8 max-w-2xl text-textmuted font-mono text-sm md:text-base leading-relaxed">
              Electronics supplier serving engineering colleges, industrial labs and
              automation projects across India.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link to="/products" className="btn-primary">
                Browse catalogue <ArrowUpRight size={14} />
              </Link>
              <Link to="/enquiry" className="btn-ghost">
                Request a quote <ArrowRight size={14} />
              </Link>
            </div>
          </div>

        <div className="bg-ink-900/70 backdrop-blur-sm border border-ink-700 rounded-3xl p-3 md:p-6 lg:p-8 mt-12 lg:-mt-16">

  {/* GEM Card */}
<div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-8 items-center">
    <div>
 <img
  src="/gem.jpeg"
  alt="GEM Total Solutions"
  className="w-full max-w-[280px] mx-auto h-40 md:h-56 object-contain rounded-xl bg-white p-2 animate-pulse"
/>
    </div>

    <div>
 <h3
  className="font-display text-2xl md:text-4xl font-black mb-4"
  style={{
    color: "var(--signal-amber)",
    textShadow: "0 0 20px rgba(255,165,0,.4)"
  }}
>
  GEM TOTAL SOLUTIONS
</h3>

      <p className="text-textmuted text-sm leading-relaxed">
        Your trusted partner for government and institutional procurement.
        Providing quality products, transparent processes and reliable
        support through the Government e-Marketplace platform.
      </p>

      <div className="mt-4 text-signal-amber font-mono">
        gem.gov.in
      </div>
    </div>
  </div>

  {/* Divider */}
  <div className="my-8 md:my-12 h-px bg-gradient-to-r from-transparent via-signal-amber to-transparent" />

  {/* CEATECH Card */}
  <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-8 items-center">
    <div>
      <img
        src="/ceatech.jpeg"
        alt="CEATECH Labs Pvt Ltd"
        className="w-full max-w-[280px] mx-auto h-40 md:h-56 object-contain rounded-xl bg-white p-2"
      />
    </div>

    <div>
<h3
  className="font-display text-2xl md:text-4xl font-black mb-4"
  style={{
    color: "var(--signal-amber)",
    textShadow: "0 0 20px rgba(255,165,0,.4)"
  }}
>
  CEATECH LABS PVT LTD
</h3>

      <p className="text-textmuted text-sm leading-relaxed">
        Engineering the future with innovative electronics solutions,
        trainer kits, instrumentation and automation systems for
        education, industry and research institutions across India.
      </p>

   <div className="mt-4 text-signal-amber font-mono">
	 

        www.ceaindia.in
      </div>
    </div>
  </div>

</div>

        </div>
      </div>
    </section>
  );
}